import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const subscriptionKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const params = req.params.set('subscription-key', environment.apimSubscriptionKey);
  return next(req.clone({ params }));
};
